import { Pipe, PipeTransform } from '@angular/core';
import { InvoiceImportChangeSeverity } from 'src/app/models/invoice-import.model';

@Pipe({ name: 'invoiceImportLineReviewClass' })
export class InvoiceImportLineReviewClassPipe implements PipeTransform {
  transform(status: string): string {
    switch (status) {
      case 'approved':
      case 'auto_approved':
      case 'auto_marked':
        return 'bg-success';
      case 'imported':
        return 'bg-primary';
      case 'rejected':
        return 'bg-secondary';
      case 'applying':
        return 'bg-warning text-dark';
      default:
        return 'bg-light text-dark';
    }
  }
}

@Pipe({ name: 'invoiceImportLineSeverityClass' })
export class InvoiceImportLineSeverityClassPipe implements PipeTransform {
  transform(severity: InvoiceImportChangeSeverity | undefined): string {
    switch (severity) {
      case 'large':
        return 'severity-large';
      case 'notice':
        return 'severity-notice';
      case 'normal':
        return 'severity-normal';
      case 'small':
        return 'severity-small';
      default:
        return 'severity-none';
    }
  }
}

@Pipe({ name: 'invoiceImportLineSeverityBadgeClass' })
export class InvoiceImportLineSeverityBadgeClassPipe implements PipeTransform {
  transform(severity: InvoiceImportChangeSeverity | undefined): string {
    switch (severity) {
      case 'large':
        return 'badge severity-badge-large';
      case 'notice':
        return 'badge severity-badge-notice';
      case 'normal':
        return 'badge severity-badge-normal';
      default:
        return 'badge bg-light text-dark';
    }
  }
}
